import React from "react";
import { TwConfirmDialog } from "./tailwind";
import { useTranslation } from "react-i18next";

export default function DeleteDialog({
  open,
  title,
  message,
  type,
  handleClose,
  handleDelete,
}) {
  const { t, i18n } = useTranslation();
  return (
    <TwConfirmDialog
      dialogOpen={open}
      dialogType="warning"
      dialogTitle={title}
      dialogMessage={message || t("myEvents.removeAddonDefaultMsg", { type: (type !== "" ? " " + type : "") })}
      onClose={handleClose}
      onConfirm={handleDelete}
    />
  )
}
